<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page signup-main">
    <h1>Sign Up</h1>
    <div class="signup-columns">
    <div class="loan-section max-w-400 w-full">
      <app-loan-input label="Email" [control]="usernameControl" />
      <app-loan-input label="Full name" [control]="fullNameControl" />
      <app-loan-input label="Password" [control]="passwordControl" type="password" [enableVisibilityToggle]="true" />
      <app-loan-input label="Repeat Password" [control]="repeatPasswordControl" type="password" [enableVisibilityToggle]="true" />

      <!-- <app-loan-checkbox class="px-20" text="Keep me signed in" groupName="Signin" [control]="keepControl" /> -->

      <div class="flex justify-between items-center">
        <app-button (click)="signup()">Sign Up</app-button>
        <p class="text-err">{{ err }}</p>
      </div>
      @if (msg) {
        <p class="pt-10">{{ msg }}</p>
      }
    </div>

    <aside class="loan-section max-w-400 w-full online-banking-cta" aria-label="Online banking sign-in">
      <p class="online-banking-cta__title">Already use online banking?</p>
      <p class="online-banking-cta__body">
        You can access the commercial loan application from Central Bank online banking after you sign in.
      </p>
      <a class="online-banking-cta__button" [href]="onlineBankingUrl" target="_blank" rel="noopener noreferrer">
        Log in to online banking
      </a>
    </aside>
    </div>
  </main>
</body>
